// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__S4oVK","upload":"Small_upload__NaXAx","imageWrap":"Small_imageWrap__1ymaW","removeBtn":"Small_removeBtn__3Vyzh"};